import { useLocation } from 'react-router-dom';
import Icon from '../ui/Icon';
import { getCurrentUser } from '../../auth/session';
import { NAV_ITEMS } from './navItems';

export default function Topbar({ onMenuClick, sidebarHidden }) {
  const { pathname } = useLocation();
  const user = getCurrentUser();
  // Also matches nested routes, e.g. /users/123 → "Users"
  const current = NAV_ITEMS.find((item) => pathname === item.to || pathname.startsWith(`${item.to}/`));

  return (
    <header
      className={`fixed top-0 right-0 left-0 h-16 z-30 bg-surface-container-lowest/95 backdrop-blur-md border-b border-outline-variant/30 grid grid-cols-[1fr_auto_1fr] items-center gap-4 px-4 sm:px-8 transition-[left] duration-200 ${
        sidebarHidden ? '' : 'lg:left-16 xl:left-[260px]'
      }`}
    >
      <div className="flex items-center">
        <button
          type="button"
          onClick={onMenuClick}
          className="p-2 -ml-2 rounded-lg text-on-surface-variant hover:bg-surface-container"
          aria-label="Toggle navigation"
        >
          <Icon name="menu" size={22} />
        </button>
      </div>

      <h2 className="text-base sm:text-lg font-bold text-primary tracking-tight text-center truncate">
        {current?.label}
      </h2>

      <div className="flex items-center justify-end gap-2 min-w-0">
        <div className="w-8 h-8 rounded-full bg-primary text-on-primary flex items-center justify-center text-xs font-semibold shrink-0">
          {user.initials}
        </div>
        <span className="text-xs font-medium text-on-surface hidden md:inline truncate">{user.name}</span>
      </div>
    </header>
  );
}
